import { useMemo } from 'react'

import {
    Card,
    DeviceDetailsDefault,
    DeviceDetailsGenerac, DeviceDetailsTesla
} from '@/components'
import { Warranty } from '@/models'

const DevicesIndex = ({ warranty }: { warranty: Warranty }) => {
    const content = useMemo(() => {
        if (warranty.inverter?.manufacturer.isGenerac) {
            return <DeviceDetailsGenerac warranty={warranty}/>
        } else if (warranty.inverter?.manufacturer.isTesla) {
            return <DeviceDetailsTesla warranty={warranty}/>
        }
        return <DeviceDetailsDefault warranty={warranty}/>
    }, [warranty])

    return <Card>
        {content}
    </Card>
}

export default DevicesIndex
